// src/pages/Login.js
import React, { useState } from 'react';
import LogoMark from '../components/LogoMark';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useStore } from '../store';
import ResendVerification from '../components/ResendVerification';
import { LegalLinks } from '../components/AuthCard';

export default function Login() {
  const navigate = useNavigate();
  const notice = useLocation().state?.notice; // e.g. after a password reset
  const { login } = useStore();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errorCode, setErrorCode] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setErrorCode(null);
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
      setErrorCode(err.response?.data?.code || null);
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f6fa' }}>
      <div style={{ width: 400, maxWidth: 'calc(100% - 32px)' }}>
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8eaf0', padding: 32 }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <LogoMark size={32} />
            <span style={{ fontSize: 20, fontWeight: 700, color: '#1a1f2e' }}>Post Calendar</span>
          </Link>
          <div style={{ fontSize: 13, color: '#8892a4' }}>Sign in to your account</div>
        </div>
        <form onSubmit={handleSubmit}>
          {notice && !error && <div style={{ padding: '10px 12px', background: '#e6f9f0', color: '#0a6640', borderRadius: 6, fontSize: 12, marginBottom: 14 }}>{notice}</div>}
          {error && (
            <div style={{ padding: '10px 12px', borderRadius: 6, fontSize: 12, marginBottom: 14, lineHeight: 1.5,
              ...(errorCode === 'pending_approval' ? { background: '#fff8e7', color: '#8a6200' } : { background: '#feeaea', color: '#b91c1c' }) }}>
              {error}
              {errorCode === 'email_unverified' && (
                <div style={{ marginTop: 8 }}><ResendVerification email={form.email} style={{ padding: '4px 10px' }} /></div>
              )}
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Email address</label>
            <input className="form-input" type="email" placeholder="you@example.com" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
          </div>
          <div className="form-group" style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <label className="form-label">Password</label>
              <Link to="/forgot-password" style={{ fontSize: 11, color: '#0f766e', fontWeight: 600 }}>Forgot password?</Link>
            </div>
            <input className="form-input" type="password" autoComplete="current-password" placeholder="••••••••" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px', fontSize: 14 }} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: '#8892a4' }}>
          Don't have an account? <Link to="/register" style={{ color: '#0f766e', fontWeight: 600 }}>Sign up</Link>
        </div>
      </div>
      <LegalLinks />
      </div>
    </div>
  );
}
